module.exports = __webpack_public_path__ + "static/media/fly0043.93b74262.webp";